export const terminalCreateAndUpdateCode = {
    "curl": {
      "request": `curl -X 'POST'
    'https://demo-api.westpay.se/access/v2/terminal/createUpdate'
    -H 'accept: text/plain'
    -H 'Ocp-Apim-Subscription-Key: <merchant-subscription-key>'
    -H 'Authorization: Bearer <access-token>'
    -H 'Content-Type: application/json'
    -d '{
    "customerId": 10796,
    "packageIds": [
      437
    ],
    "serialNumbers": [
      "1043005005"
    ]
  }'`
    },
    "java": {
      "request": `import java.net.URI;
    import java.net.http.HttpClient;
    import java.net.http.HttpRequest;
    import java.net.http.HttpResponse;
    import java.net.http.HttpHeaders;
    import java.util.Arrays;
    import java.util.List;
    import java.util.concurrent.CompletableFuture;
    import com.google.gson.Gson;
      
    public class Main {
        public static void main(String[] args) throws Exception {
            // Create TerminalRequest object
            TerminalRequest requestObj = new TerminalRequest(10796, Arrays.asList(437), Arrays.asList("1043005005"));
      
            // Convert request object to JSON string
            Gson gson = new Gson();
            String requestBody = gson.toJson(requestObj);
      
            // Define your headers
            String subscriptionKey = "<merchant-subscription-key>";
            String accessToken = "<access-token>";
      
            // Create an HttpClient
            HttpClient client = HttpClient.newHttpClient();
      
            // Build the request
            HttpRequest request = HttpRequest.newBuilder()
                    .uri(URI.create("https://demo-api.westpay.se/access/v2/terminal/createUpdate"))
                    .header("accept", "text/plain")
                    .header("Ocp-Apim-Subscription-Key", subscriptionKey)
                    .header("Authorization", "Bearer " + accessToken)
                    .header("Content-Type", "application/json")
                    .POST(HttpRequest.BodyPublishers.ofString(requestBody))
                    .build();
      
            // Send the request asynchronously
            CompletableFuture<HttpResponse<String>> responseFuture = client.sendAsync(request, HttpResponse.BodyHandlers.ofString());
      
            // Handle the response
            responseFuture.thenAccept(response -> {
                int statusCode = response.statusCode();
                HttpHeaders headers = response.headers();
                String responseBody = response.body();
      
                System.out.println("Status code: " + statusCode);
                System.out.println("Response headers: " + headers);
                System.out.println("Response body: " + responseBody);
            });
      
            // Wait for the response to be available
            responseFuture.join();
        }
      
        static class TerminalRequest {
            private int customerId;
            private List<Integer> packageIds;
            private List<String> serialNumbers;
      
            // Constructor, getters, and setters
            public TerminalRequest(int customerId, List<Integer> packageIds, List<String> serialNumbers) {
                this.customerId = customerId;
                this.packageIds = packageIds;
                this.serialNumbers = serialNumbers;
            }
      
            public int getCustomerId() {
                return customerId;
            }
      
            public void setCustomerId(int customerId) {
                this.customerId = customerId;
            }
      
            public List<Integer> getPackageIds() {
                return packageIds;
            }
      
            public void setPackageIds(List<Integer> packageIds) {
                this.packageIds = packageIds;
            }
      
            public List<String> getSerialNumbers() {
                return serialNumbers;
            }
      
            public void setSerialNumbers(List<String> serialNumbers) {
                this.serialNumbers = serialNumbers;
            }
        }
    }
      `
    },
    "C#": {
      "request": `using System;
    using System.Collections.Generic;
    using System.Net.Http;
    using System.Text;
    using System.Text.Json;
    using System.Threading.Tasks;
      
    class Program
    {
        static async Task Main(string[] args)
        {
            // Create TerminalRequest object
            TerminalRequest requestObj = new TerminalRequest
            {
                CustomerId = 10796,
                PackageIds = new List<int> { 437 },
                SerialNumbers = new List<string> { "1043005005" }
            };
      
            // Convert request object to JSON string
            string requestBody = JsonSerializer.Serialize(requestObj);
      
            // Define your headers
            string subscriptionKey = "<merchant-subscription-key>";
            string accessToken = "<access-token>";
      
            // Create HttpClient instance
            using var client = new HttpClient();
    
            // Build the request
            HttpRequestMessage request = new HttpRequestMessage
            {
                RequestUri = new Uri("https://demo-api.westpay.se/access/v2/terminal/createUpdate"),
                Method = HttpMethod.Post,
                Content = new StringContent(requestBody, Encoding.UTF8, "application/json")
            };
            request.Headers.Add("accept", "text/plain");
            request.Headers.Add("Ocp-Apim-Subscription-Key", subscriptionKey);
            request.Headers.Add("Authorization", "Bearer " + accessToken);
      
            // Send the request asynchronously
            HttpResponseMessage response = await client.SendAsync(request);
      
            // Handle the response
            int statusCode = (int)response.StatusCode;
            string responseBody = await response.Content.ReadAsStringAsync();
      
            Console.WriteLine($"Status code: {statusCode}");
            Console.WriteLine($"Response body: {responseBody}");
        }
      
        class TerminalRequest
        {
            public int CustomerId { get; set; }
            public List<int> PackageIds { get; set; }
            public List<string> SerialNumbers { get; set; }
        }
    }
      `
    },
    "python": {
      "request": `import requests
    import json
      
    def main():
        # Define your request body
        request_body = {
            "customerId": 10796,
            "packageIds": [437],
            "serialNumbers": ["1043005005"]
        }
      
        # Define your headers
        headers = {
            "accept": "text/plain",
            "Ocp-Apim-Subscription-Key": "<merchant-subscription-key>",
            "Authorization": "Bearer <access-token>",
            "Content-Type": "application/json"
        }
      
        # Send the request
        response = requests.post(
            'https://demo-api.westpay.se/access/v2/terminal/createUpdate',
            headers=headers,
            json=request_body
        )
      
        # Handle the response
        status_code = response.status_code
        response_body = response.text
      
        print(f"Status code: {status_code}")
        print(f"Response body: {response_body}")
      
    if __name__ == "__main__":
        main()
      `
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');
    async function main() {
        // Define your request body
        const requestBody = {
            customerId: 10796,
            packageIds: [437],
            serialNumbers: ["1043005005"]
        };
      
        // Define your headers
        const headers = {
            'accept': 'text/plain',
            'Ocp-Apim-Subscription-Key': '<merchant-subscription-key>',
            'Authorization': 'Bearer <access-token>',
            'Content-Type': 'application/json'
        };
      
        // Send the request
        try {
            const response = await axios.post('https://demo-api.westpay.se/access/v2/terminal/createUpdate', requestBody, {
                headers: headers
            });
      
            // Handle the response
            const status = response.status;
            const responseBody = response.data;
  
        } catch (error) {
            console.error('Error:', error.message);
        }
    }
    main();
      `
    }
  };
  
  export const terminalCreateAndUpdateCodeResponse = `{
        "createConfigurationFileResults": [
          {
            "serialNumber": "<serial_number>",
            "isUploadSuccessful": true,
            "message": null
          }
        ]
      }`;
  